const titleEl = document.getElementById("ingredientTitle");
const descEl = document.getElementById("ingredientDesc");

function updateIngredientText(swiper) {
    let offset = 0;
    const width = window.innerWidth;

    if (width >= 1024) {
        offset = 2; // 3rd slide
    } else if (width >= 768) {
        offset = 1; // 2nd slide
    } else {
        offset = 0; // active slide
    }

    const targetIndex = swiper.activeIndex + offset;
    const targetSlide = swiper.slides[targetIndex];

    if (!targetSlide) return;

    titleEl.textContent = targetSlide.dataset.title || "";
    descEl.textContent = targetSlide.dataset.desc || "";
}

const ingredientsSwiper = new Swiper(".ingredients__slider", {
    slidesPerView: 5,
    centeredSlides: false,
    loop: true,
    spaceBetween: 42,
    speed: 600,

    navigation: {
        nextEl: ".ingredients__arrow--right",
        prevEl: ".ingredients__arrow--left"
    },

    pagination: {
        el: ".ingredients__pagination",
        clickable: true
    },

    on: {
        init(swiper) {
            updateIngredientText(swiper);
        },
        slideChangeTransitionEnd(swiper) {
            updateIngredientText(swiper);
        },
        resize(swiper) {
            updateIngredientText(swiper);
        }
    },

    breakpoints: {
        0: {
            slidesPerView: 1
        },
        768: {
            slidesPerView: 3
        },
        1024: {
            slidesPerView: 5
        }
    }
});